var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('BaseHeader',{on:{"show-sidebar":_vm.handleSidebar}}),_c('router-view'),_c('BaseFooter',{attrs:{"showSideBar":_vm.isShowSideBar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }